import React, { useState, useEffect } from 'react';
import HomeLoan from './HomeLoan';
import EligibilityChecker from './EligibilityCheck';

export default function LoanCalculators() {
  const [activeTab, setActiveTab] = useState('eligibility');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300); 
    return () => clearTimeout(timer);
  }, [activeTab]);

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Header */}
      <div className="bg-accent py-6 shadow-md sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col items-center justify-center">
            <h1 className="text-2xl font-bold mt-20 text-white">Your Dream Home Awaits</h1>
            <div className="flex flex-col space-x-0 md:flex-row md:space-x-4 font-semibold w-full md:w-auto mt-4 px-4 md:px-0">
              <button
                className={`py-2 px-4 mt-2 rounded-full transition-colors duration-200 w-full md:w-auto text-center ${
                  activeTab === 'eligibility' ? 'bg-white text-accent' : 'text-white hover:bg-gray-400'
                }`}
                onClick={() => setActiveTab('eligibility')}
              >
                Home Loan Eligibility Calculator
              </button>
              <button
                className={`py-2 px-4 mt-2 rounded-full transition-colors duration-200 w-full md:w-auto text-center ${
                  activeTab === 'emi' ? 'bg-white text-accent' : 'text-white hover:bg-gray-400'
                }`}
                onClick={() => setActiveTab('emi')}
              >
                Home Loan EMI Calculator
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto p-4 md:p-2">
        <h1 className="text-lg md:text-4xl font-extrabold text-gray-800 text-center mb-8">
          {activeTab === 'emi' ? 'Home Loan EMI Calculator' : 'Home Loan Eligibility Calculator'}
        </h1>
        {isLoading ? (
          <div className="flex justify-center items-center min-h-[400px]">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-accent"></div>
          </div>
        ) : (
          activeTab === 'emi' ? <HomeLoan /> : <EligibilityChecker />
        )}
      </div>
    </div>
  );
}